export function call(method, target, ...payload) {
	if (!target) return false

	;[target].flat().forEach((entry) => {
		if (entry && typeof entry[method] === 'function') {
			entry[method](...payload)
		}
	})
}

export function fuid() {
	const timestamp = (typeof performance !== 'undefined' && performance.now()) || Date.now()
	const random = Math.random().toString().slice(10, 14)

	return `${Number(random).toString(32)}_${timestamp.toString(32)}`.replace(/\./g, '_')
}
